"use client";

import { useSidebar } from "@/components/ui/sidebar";

/**
 * The build the user is looking at.
 *
 * The product had no version anywhere: apps/api said 0.0.1, apps/web 0.1.0, the
 * root package.json 3.0.0, and none of them were maintained. When someone
 * reports a bug there was no way to establish which build they were on — and
 * the product is in beta, where that question comes up constantly.
 *
 * The value is inlined at BUILD time from the same computation the API uses
 * (apps/api/scripts/release-version.cjs, via next.config.ts), so what is shown
 * here, what `/v1/health/version` returns and what Sentry groups by are one
 * number by construction rather than by discipline.
 *
 * Deliberately WITHOUT the commit, matching the API's public endpoint. The full
 * release lives in Sentry and in `dist/release.json` on the box.
 */
export function AppVersion() {
  const { state } = useSidebar();
  const version = process.env.NEXT_PUBLIC_APP_VERSION;

  // Absent in a dev server started without the config, and in any build that
  // predates this. Render nothing rather than "undefined".
  if (!version) return null;

  // Collapsed rail is icon-width; a version string there would just clip.
  if (state === "collapsed") return null;

  return (
    <div
      className="px-2 pb-1 text-[10px] leading-none text-sidebar-foreground/70 select-text"
      title={`HumanFirewall ${version}${
        process.env.NEXT_PUBLIC_APP_BUILD_DATE
          ? ` — built ${process.env.NEXT_PUBLIC_APP_BUILD_DATE}`
          : ""
      }`}
      data-testid="app-version"
    >
      v{version}
    </div>
  );
}
